import { render, staticRenderFns } from "./FriendlyLink.vue?vue&type=template&id=a36b44c0&scoped=true&"
import script from "./FriendlyLink.vue?vue&type=script&lang=js&"
export * from "./FriendlyLink.vue?vue&type=script&lang=js&"
import style0 from "./FriendlyLink.vue?vue&type=style&index=0&id=a36b44c0&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36b44c0",
  null
  
)

export default component.exports